import { render, staticRenderFns } from "./SendCSV.vue?vue&type=template&id=4888d0d6&scoped=true"
import script from "./SendCSV.vue?vue&type=script&lang=js"
export * from "./SendCSV.vue?vue&type=script&lang=js"
import style1 from "./SendCSV.vue?vue&type=style&index=1&id=4888d0d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4888d0d6",
  null
  
)

export default component.exports